module.exports = __webpack_public_path__ + "static/media/Qapter_presentation-12.d8c01bc0.jpg";